<template>
<div class="col body">
  <div style="flex:0 0 90px;">
    <div class="row" style="padding-bottom: 6px;">
      <div class="row text-h6">
        템플릿 목록
        <q-btn dense flat icon="help_outline" @click="state.dialogHelp = true" size="xs" style="margin:3px 0px 0px 3px;" />
      </div>
      <q-space />
      <div class="row text-caption" style="align-items:center">
        템플릿 목록 갱신 시점: {{state.refreshTime}}
        <q-btn dense flat icon="refresh" size="md" @click="refresh">
          <q-tooltip>서버에서 최신 템플릿 목록 정보를 받아오기</q-tooltip>
        </q-btn>
      </div>
    </div>
    
    <q-btn-group dense spread>
      <q-btn color="primary" dense rounded icon="add" label="템플릿 생성" @click="state.dialogTemplateCreation = {show: true}" />
      <q-separator vertical />
      <q-btn color="primary" dense rounded label="삭제" :disable="state.table.selected.length == 0" @click="state.dialogTemplateDelete = true" />
    </q-btn-group>
  </div>
  <div class="column col">
    <!-- eslint-disable vue/valid-v-model -->
    <q-table
      ref="table"
      v-if="state.table.data.length > 0"
      dense
      table-header-class="bg-secondary text-white"
      :data="state.table.data"
      :columns="state.table.columns"
      row-key="templateId"
      selection="multiple"
      :selected.sync="state.table.selected"
      :pagination.sync="state.table.pagenation"
      :filter="state.table.filter"
      :filter-method="tableFilter"
      virtual-scroll
    >
      <template v-slot:bottom>
        <div class="row" style="align-items:center;">
          <q-icon name="search" size="xs" color="grey" />
          <input ref="table-search" placeholder="Search..." style="border:none;margin-left:3px;" @input="listen__table__filter" />
        </div>
        <q-space />
        <div class="row" style="align-items:center;">
          <span v-if="state.table.selected.length > 0">{{state.table.selected.length}} record{{state.table.selected.length > 1 ? 's':''}} selected.</span>
          <span style="margin-left:25px;">Records per page:</span>
          <select v-model="state.table.pagenation.rowsPerPage" style="margin-left:5px;">
            <option v-for="(value, index) in state.table.pagenation.rowsPerPageValues" :key="`${index}`" :label="value" :value="value" />
          </select>
          <q-pagination
            v-model="state.table.pagenation.page"
            color="secondary"
            :max="state.table.pagenation.max"
            :max-pages="5"
            :boundary-numbers="false"
            boundary-links
            size="sm"
            style="margin-left:15px;"
          />
        </div>
      </template>
      <template v-slot:no-data>
        <div class="row" style="align-items:center;">
          <q-icon name="search" size="xs" color="grey" />
          <input ref="table-search" placeholder="Search..." style="border:none;margin-left:3px;" @input="listen__table__filter" />
        </div>
        <q-space />
        <div class="row" style="align-items:center;">
          <span v-if="state.table.selected.length > 0">{{state.table.selected.length}} record{{state.table.selected.length > 1 ? 's':''}} selected.</span>
        </div>
      </template>
      <template v-slot:body-cell-modify="props">
        <q-td :props="props">
          <div>
            <q-btn dense flat icon="edit" size="xs" @click="listen__template_modification_view__onopen(props)" />
          </div>
        </q-td>
      </template>
      <template v-slot:body-cell-download="props">
        <q-td :props="props">
          <q-btn dense flat icon="download" size="xs" @click="listen__template__ondownload(props)" />
        </q-td>
      </template>
    </q-table>
    <div class="column col text-grey-7" v-else>
      <div style="flex:1 0 0;display:flex;flex-direction:column;justify-content:center;align-items:center;">
        <q-icon name="warning" class="text-red q-pa-sm" size="md" />
        <div>템플릿 데이터 없음.</div>
        <div>[+ 템플릿 생성]을 클릭하여 새 템플릿을 만드십시오.</div>
      </div>
      <div style="flex:1 1 0;">
      </div>
    </div>
  </div>
  <template-creation-view v-if="state.dialogTemplateCreation.show"
    :templateData="state.dialogTemplateCreation.templateData"
    @onsave="listen__template_creation_view__onsave"
    @onmodify="listen__template_creation_view__onsave"
    @onclose="listen__template_creation_view__onclose"/>
  <q-dialog v-model="state.dialogHelp">
    <q-card>
      <q-card-section>
        <div class="text-h6">템플릿 목록</div>
      </q-card-section>

      <q-card-section class="q-pt-none">
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Rerum repellendus sit voluptate voluptas eveniet porro. Rerum blanditiis perferendis totam, ea at omnis vel numquam exercitationem aut, natus minima, porro labore.
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="확인" color="primary" v-close-popup />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-dialog v-model="state.dialogTemplateDelete">
    <q-card>
      <q-card-section class="row items-center">
        <q-icon name="report" color="primary" size="md" />
        <span class="q-ml-sm">아래 {{state.table.selected.length}}개의 템플릿을 삭제하시겠습니까?</span>
      </q-card-section>

      <q-card-section class="row items-center">
        <span class="q-ml-sm">{{state.table.selected.map(v => v.templateName)}}</span>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn flat label="취소" color="primary" v-close-popup />
        <q-btn flat label="삭제" color="primary" @click="deleteTemplate" />
      </q-card-actions>
    </q-card>
  </q-dialog>
  <q-inner-loading :showing="state.loadingLayer.show">
    <q-spinner-facebook
        color="primary"
        size="2em"
      />
    {{state.loadingLayer.message}}
  </q-inner-loading>
</div>
</template>

<script>
/* eslint-disable no-unused-vars */
import TemplateCreationView from '@/projects/template_ocr/views/TemplateCreationView.vue'

import lodash from 'lodash'

import COMM from '@/js/comm.js'
import MISC from '@/js/miscellaneous.js'
import PARSE from '@/js/parse.js'

export default {
  components: {
    TemplateCreationView
  },
  data: function () {
    return {
      state: {
        dialogHelp: false,
        dialogTemplateCreation: {
          show: false
        },
        dialogTemplateDelete: false,
        loadingLayer: {
          show: false,
          message: ''
        },
        table: {
          filter: '',
          pagenation: {
            sortBy: 'desc',
            descending: false,
            page: 1,
            rowsPerPage: 10,
            max: 10,
            rowsPerPageValues: []
          },
          selected: [],
          columns: [
            { name: 'templateName', label: '템플릿 명', field: 'templateName', sortable: true, align: 'left' },
            { name: 'fieldCount', label: '판독필드 수', field: 'fieldCount', sortable: true },
            { name: 'creationDate', label: '생성 일시 (UTC+09:00)', field: 'creationDate', sortable: true},
            { name: 'creationBy', label: '생성한 사람', field: 'creationBy', sortable: true},
            { name: 'modify', label: '템플릿 수정', field: 'modify' },
            { name: 'download', label: '다운로드', field: 'download' }
          ],
          data: []
        },
        refreshTime: 'null'
      }
    }
  },
  methods: {
    listen__template_creation_view__onsave: function () {
      this.state.dialogTemplateCreation = {
        show: false
      }
      this.refresh()
    },
    listen__template_creation_view__onclose: function () {
      this.state.dialogTemplateCreation = {
        show: false
      }
    },
    listen__template__ondownload: async function (e) {
      let fileName = `${e.row.templateName}.json`
      this.$q.notify({message: `${fileName} 를 다운로드 합니다. 잠시만 기다려 주세요.`, icon: 'error',color: 'black'})
      let ret;
      try {
        ret = await COMM.getTemplate(e.row.templateId);
        this.download(fileName, JSON.stringify(ret.data, null, 2))
      } catch {
        this.$q.notify({
          message: `${fileName}의 다운로드에 실패 했습니다.`,
          icon: 'announcement',
          color: 'red'
        })
        this.state.loadingLayer = {
          show: false,
          message: ''
        }
        return;
      }
    },
    listen__template_modification_view__onopen: async function (e) {
      this.state.loadingLayer = {
        show: true,
        message: '샘플 이미지를 불러 오는 중 입니다.'
      }
      let template;
      try {
        const ret = await COMM.getTemplate(e.row.templateId);
        template = ret.data
        const fieldColors = this.$store.state.constant.fieldColors
        for (let idx in template.fields) {
          let field = template.fields[idx]
          field.id = MISC.getUuid4()
          field.color = fieldColors[idx % fieldColors.length]
        }
      } catch {
        this.$q.notify({
          message: '템플릿을 불러오지 못했습니다.',
          icon: 'announcement',
          color: 'red'
        })
        this.state.loadingLayer = {
          show: false,
          message: ''
        }
        return;
      }

      let imageData
      try {
        let ret = await COMM.getSample(e.row.templateId);
        const bytes = MISC.convertBase64ToBuffer(ret.data)
        if (e.row.sampleFileExtension == 'jpg')
          imageData = await PARSE.parseJpg(bytes)
        else if (e.row.sampleFileExtension == 'png')
          imageData = await PARSE.parsePng(bytes)
        else
          throw "unsupported extension"
      } catch {
        this.$q.notify({
          message: `샘플 이미지의 다운로드에 실패 했습니다.`,
          icon: 'announcement',
          color: 'red'
        })
        this.state.loadingLayer = {
          show: false,
          message: ''
        }
        return;
      }
      this.state.dialogTemplateCreation = {
        show: true,
        templateData: {
          template,
          imageData
        }
      }
      this.state.loadingLayer = {
        show: false,
        message: ''
      }
    },
    listen__table__filter: lodash.debounce(function () {
      this.state.table.filter = this.$refs['table-search'].value
    }, 300),
    refresh: async function () {
      this.state.loadingLayer = {
        show: true,
        message: '템플릿을 불러오는 중 입니다.'
      }
      let ret;
      try {
        ret = await COMM.getTemplate();
      } catch {
        this.$q.notify({
          message: '템플릿을 불러오지 못했습니다.',
          icon: 'announcement',
          color: 'red'
        })
        this.state.loadingLayer = {
          show: false,
          message: ''
        }
        return;
      }
      
      let tableData = []
      for (let row of ret.data) {
        tableData.push({
          templateId: row.templateId,
          templateName: row.templateName,
          fieldCount: row.fields.length,
          modify: '',
          creationDate: row.creationDate,
          creationBy: row.creationBy,
          download: '',
          sampleFileExtension: row.sampleFileExtension
        })
      }
      this.state.table.pagenation = {
        sortBy: 'desc',
        descending: false,
        page: 1,
        rowsPerPage: 10,
        max: Math.ceil(tableData.length / 10),
        rowsPerPageValues: [1, 5, 10, 20, 50]
      }
      this.state.table.data = tableData
      this.state.loadingLayer = {
        show: false,
        message: ''
      }
      this.state.refreshTime = new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().split('.')[0].replace('T', ' ')
    },
    deleteTemplate: async function () {
      this.state.dialogTemplateDelete = false
      this.state.loadingLayer = {
        show: true,
        message: '템플릿을 삭제하는 중 입니다.'
      }
      for (let row of this.state.table.selected) {
        try {
          await COMM.deleteTemplate(row.templateId);
        } catch (ret){
          this.$q.notify({
            message: ret.message,
            icon: 'announcement',
            color: 'red'
          })
        }
      }
      this.refresh()
      this.$refs['table'].clearSelection()
    },
    download: function (filename, text) {
      var element = document.createElement('a');
      element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text));
      element.setAttribute('download', filename);

      element.style.display = 'none';
      document.body.appendChild(element);

      element.click();

      document.body.removeChild(element);
    },
    tableFilter: function(rows) {
      let ret = []
      for (const row of rows) { 
        let found = false
        for (const value of Object.values(row)) {
          if (value.toString().indexOf(this.state.table.filter) != -1)
            found = true
        }

        if (found == true)
          ret.push(row)
      }
      return ret
    }
  },
  computed: {
    tableFilteredRow: function () {
      let ret = []
      for (const row of this.state.table.data) { 
        let found = false
        for (const value of Object.values(row)) {
          if (value.toString().indexOf(this.state.table.filter) != -1)
            found = true
        }

        if (found == true)
          ret.push(row)
      }
      return ret
    }
  },
  watch: {
    'state.table.filter': function () {
      this.state.table.pagenation.max = Math.ceil(this.tableFilteredRow.length / this.state.table.pagenation.rowsPerPage)
    },
    'state.table.pagenation.rowsPerPage': function (v) {
      this.state.table.pagenation.max = Math.ceil(this.tableFilteredRow.length / this.state.table.pagenation.rowsPerPage)
    }
  },
  mounted () {
    this.refresh()
  }
}
</script>

<style scoped>
.body {
  display: flex;
  flex-direction: column;
}
</style>
